export default function SectionAbout() {
  return (
    <section id="about" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[800px] mx-auto">
        <div className="bg-background-100 rounded-2xl p-8 md:p-10">
          <div className="text-center mb-8">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
              关于五一黑料网
            </h2>
            <p className="text-foreground-600 text-sm">
              全网最专业的黑料吃瓜内容聚合平台
            </p>
          </div>

          <div className="space-y-5 text-sm md:text-base text-foreground-700 leading-relaxed">
            <p>
              五一黑料网成立于2020年，是国内领先的黑料吃瓜内容聚合平台。我们专注于收集、整理和呈现全网最热门的
              黑料爆料、内幕事件和吃瓜动态，致力于为广大吃瓜群众提供一站式的热点追踪体验。
            </p>
            <p>
              平台覆盖娱乐圈、网红圈、商业圈等多个垂直领域，每日追踪微博、抖音、小红书、豆瓣等50余个主流平台的
              最新爆料内容。通过专业的编辑团队和智能化的内容筛选系统，确保每一条信息都经过严格审核，
              为读者呈现真实、及时、全面的瓜田爆料。
            </p>
            <p>
              截至目前，五一黑料网已累计收录超过10万条黑料内容，日均服务数百万吃瓜用户。
              我们始终秉持"真实、快速、全面"的原则，在信息爆炸的时代为读者提供值得信赖的吃瓜参考。
            </p>
          </div>

          <div className="grid grid-cols-3 gap-4 mt-8 pt-8 border-t border-background-200">
            <div className="text-center">
              <span className="block text-2xl md:text-3xl font-black text-primary-500 font-heading">10万+</span>
              <span className="text-xs text-foreground-500 mt-1">累计爆料收录</span>
            </div>
            <div className="text-center">
              <span className="block text-2xl md:text-3xl font-black text-primary-500 font-heading">50+</span>
              <span className="text-xs text-foreground-500 mt-1">覆盖内容平台</span>
            </div>
            <div className="text-center">
              <span className="block text-2xl md:text-3xl font-black text-primary-500 font-heading">百万</span>
              <span className="text-xs text-foreground-500 mt-1">日均吃瓜用户</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}